import React, {useState} from "react";
import {Conductor} from "@models/conductor";
import {Button, Card, Icon, Row, Col} from "antd";
import {FormattedMessage} from "react-intl";
import SearchStatsComponent from "@components/reports/Search";
import whitListData from "@hocs/withListData";
import supplierApi from "@api/supplier";
import withPaginationComponent from "@hocs/withPaginationComponent";
import SuppliersStatsTable from "@components/reports/SuppliersStatsTable";
import {BASE_URL} from "../../api/httpRequest";
import {getFormattedPrice} from "@utils";
import {useSelector} from "react-redux";


interface PropsFromHoc {
  data: Conductor[];
  isFetched: boolean;
  currentPage: number;
  search: (params: object | null) => void;
  onDeleteItem: (id: string) => void;
}


type AllProps = PropsFromHoc ;

const SuppliersStatsPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  const [downloadUrl, setDownloadUrl] = useState(null)
  const access_token = useSelector(state => state.auth.access_token);
  
  const deleteConductor = (item: Conductor): any => {
    const {onDeleteItem} = props;
    supplierApi.delete({
        params: {
          channel_id: item.channel.id,
          conductor_id: item.id
        }
      })
      .then(() => {
        onDeleteItem(item.id)
      })
      .catch(error => console.log(error))
  };
  
  const applySearch = (params) => {
    search(params)
    if (params.supplier_id) {
      const {supplier_id, ...rest} = params
      const url = `${BASE_URL}/suppliers/${supplier_id}/stats/_report?${new URLSearchParams({...rest, access_token}).toString()}`;
      setDownloadUrl(url)
    }
    else {
    
    }
  };
  
  return (
    <div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchStatsComponent search={applySearch}/>
        </Card>
        
        <Card>
          <Row className={'report'}>
            <Col span={20}>
              <FormattedMessage
                id="app.total_stat"
                defaultMessage={`Total Stat`}
              />
              {`:  `}
              {getFormattedPrice(data.total_amount || 0)}
            </Col>
  
            {!!downloadUrl && !!data.total_amount && (
              <Col span={4} className={'download-btn-wrapper'}>
                <a href={downloadUrl}>
                  <Button type={"primary"}>
                    <Icon type="file-excel"/>
                    <FormattedMessage
                      id="app.download_excel_file"
                      defaultMessage={`Download Excel File`}
                    />
                  </Button>
                </a>
              </Col>
            )}
          </Row>
        </Card>
        
        <SuppliersStatsTable
          data={data.stats}
          currentPage={currentPage}
          rowKey={record => record.id}
          deleteFn={deleteConductor}
          loading={false}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(SuppliersStatsPage),
  {
    fetchRequest: supplierApi.fetchStats,
    paginationOnScroll: false,
    initialFetch: false
  }
);
